var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "footer-address white--text" },
    [
      _c(
        "v-row",
        { attrs: { align: "center", justify: "center" } },
        [
          _c("v-col", { attrs: { cols: "6", sm: "6" } }, [
            _c("p", { staticClass: "mb-0" }, [
              _vm._v("Zoo Liberec, příspěvková organizace")
            ]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("Lidové sady 425/1")]),
            _c("p", { staticClass: "mb-0" }, [_vm._v("460 01 Liberec")])
          ]),
          _c(
            "v-col",
            { staticClass: "text-right", attrs: { cols: "6", sm: "6" } },
            [
              _c(
                "a",
                {
                  staticClass: "no-decoration white--text mr-2",
                  attrs: {
                    href: "https://elpass.zooliberec.cz",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      src: require("../../assets/web_ikona.svg"),
                      width: "24"
                    }
                  })
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "no-decoration white--text",
                  attrs: {
                    href: "https://www.facebook.com/zooliberec",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      src: require("../../assets/facebook_ikona.svg"),
                      width: "24"
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      ),
      _c("v-row", [_c("v-col", { staticClass: "pb-0" }, [_c("hr")])], 1),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "d-flex", attrs: { cols: "6", sm: "6" } },
            [
              _c("img", {
                staticClass: "mr-2",
                attrs: {
                  src: require("../../assets/lk_logo.svg"),
                  height: "36"
                }
              }),
              _vm._v("Projekt vznikl pod záštitou Libereckého kraje")
            ]
          ),
          _c(
            "v-col",
            { staticClass: "text-right", attrs: { cols: "6", sm: "6" } },
            [
              _c(
                "a",
                {
                  staticClass: "no-decoration white--text mr-2",
                  attrs: {
                    href: "https://www.tiktok.com/@regionliberec",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      src: require("../../assets/ticktock_ikona.svg"),
                      width: "24"
                    }
                  })
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "no-decoration white--text mr-2",
                  attrs: {
                    href: "https://www.instagram.com/regionliberec",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      src: require("../../assets/instagram_ikona.svg"),
                      width: "24"
                    }
                  })
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "no-decoration white--text mr-2",
                  attrs: {
                    href: "https://www.liberecky-kraj.cz",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      src: require("../../assets/web_ikona.svg"),
                      width: "24"
                    }
                  })
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "no-decoration white--text",
                  attrs: {
                    href: "https://www.facebook.com/regionliberec",
                    target: "_blank"
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      src: require("../../assets/facebook_ikona.svg"),
                      width: "24"
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }